import '@/javascripts/effects';
import './news.scss';

import Vue from 'vue';
import events from '@/Vue/eventsApp';
import newsApp from '@/Vue/newsApp';
import footerApp from '@/Vue/footerApp';
import articlesApp from '@/Vue/articlesApp';
import speakerAndPress from '@/Vue/speakerAndPressApp';
import openAndCloseModal from '@/Vue/openAndCloseModalApp';

import { getContent } from '@/javascripts/contentful';
import { checkDataStructure } from '@/javascripts/checkDataStructure';

getContent('2GSjYkSe00teog6Csboceh').then(({ fields }) => {
  // retrieve ctf
  // eslint-disable-next-line no-new
  new Vue({
    el: '#eventsApp',
    data: {
      events: fields.events,
      count: 20,
    },
    components: {
      events,
    },
  });

  // eslint-disable-next-line no-new
  new Vue({
    el: '#gppNewsApp',
    data: {
      articles: fields.gppNews,
    },
    components: {
      newsApp,
    },
  });

  // gppBlickpunkte
  const {
    newsletterModalSidebarSubline,
    newsletterModalSidebarTitle,
    newsletterModalHeading,
    newsletterModalTitle1,
    newsletterModalDescription1,
    newsletterModalTitle2,
    newsletterModalDescription2,
  } = fields.newsletterAnmeldungModalText.fields;

  // eslint-disable-next-line no-new
  new Vue({
    el: '#gppBlickpunkteApp',
    data: {
      articles: fields.gppBlickpunkte,
      newsletterModalSidebarSubline,
      newsletterModalSidebarTitle,
      newsletterModalHeading,
      newsletterModalTitle1,
      newsletterModalDescription1,
      newsletterModalTitle2,
      newsletterModalDescription2,
    },
    components: {
      articlesApp,
    },
  });

  // eslint-disable-next-line no-new
  new Vue({
    el: '#openAndCloseModalApp',
    data: {
      newsletterModalSidebarSubline,
      newsletterModalSidebarTitle,
      newsletterModalHeading,
      newsletterModalTitle1,
      newsletterModalDescription1,
      newsletterModalTitle2,
      newsletterModalDescription2,
      label: fields.newsletterSignUp.fields.ctaBtnLabel,
      title: fields.newsletterSignUp.fields.ctaSeoTitle,
    },
    components: {
      openAndCloseModal,
    },
  });

  // eslint-disable-next-line no-new
  new Vue({
    el: '#speakerAndPressApp',
    data: {
      speakerAndPress: fields.press,
    },
    components: {
      speakerAndPress,
    },
  });

  checkDataStructure(fields.pageId);
  checkDataStructure(fields.hero);
  checkDataStructure(fields.gppNews);
  checkDataStructure(fields.gppBlickpunkte);
  checkDataStructure(fields.newsletterSignUp);
  checkDataStructure(fields.events);
  checkDataStructure(fields.press);
  checkDataStructure(fields.footer);
});

// eslint-disable-next-line no-new
new Vue({
  el: '#footerApp',
  components: {
    footerApp,
  },
});
